import { categories } from '../categories';
import type { Category } from '../constants';

export async function fetchCategories(): Promise<Category[]> {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // Return local categories data
  return categories;
}